export default __webpack_public_path__ + "static/media/email.605d8eea.svg";